import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatosSimulacionSaludComponent } from '../../components/datos-simulacion-salud/datos-simulacion-salud.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	standalone: true,
	imports: [
		CommonModule,
		DatosSimulacionSaludComponent, 
		TranslateModule
	],
	templateUrl: './datos-simulacion-salud.view.html',
	styleUrls: ['./datos-simulacion-salud.view.scss']
})
export class DatosSimulacionSaludView {}
